import {
  getFrontList
} from '@/api/technicalR'
const industryList = require('@/utils/industryList')
export const Mixin = {
  data() {
    return {
      tableList: [],
      params: {
        pageNum: 1,
        pageSize: 10,
        industrialType: 4
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.loading = true
      let params = {
        name: '',
        demandsType: '',
        searchValue: '',
        industrialType: this.params.industrialType,
        params: {
          sortType: ' ',
          sort: 'asc'
        },
        companyType: '',
        tag: ''
      }
      let {
        data
      } = await getFrontList(this.params, params)
      this.loading = false

      this.tableList = data.rows

      let list = [{
          name: '技术难题',
          value: '1',
          key: 'demandsType1'
        },
        {
          name: '产品需求',
          value: '2',
          key: 'demandsType2'
        },
        {
          name: '服务需求',
          value: '3',
          key: 'demandsType3'
        },
        {
          name: '其他需求',
          value: '4',
          key: 'demandsType4'
        },
        {
          name: '不限',
          value: '',
          key: 'demandsType'
        }
      ]
      let industList = industryList.industryList
      let techList = [{
          label: '人类生活必需',
          value: '0'
        },
        {
          label: '作业；运输',
          value: '1'
        },
        {
          label: '化学；冶金',
          value: '2'
        },
        {
          label: '纺织；造纸',
          value: '3'
        },
        {
          label: '固定建筑物',
          value: '4'
        },
        {
          label: '机械工程；照明；加热；武器；爆破',
          value: '5'
        },
        {
          label: '物理',
          value: '6'
        },
        {
          label: '电学',
          value: '7'
        }
      ]
      this.tableList.forEach(item => {
        list.forEach(ele => {
          if (item.demandsType === ele.value) {
            item.demandsTypeStr = ele.name
          }
        })
        industList.forEach(ele => {
          if (item.industrialType === ele.value) {
            item.industrialTypeStr = ele.label
          }
        })
        techList.forEach(ele => {
          if (item.technicalType === ele.value) {
            item.technicalTypeStr = ele.label
          }
        })
      })

      this.isEmpty = this.tableList.length === 0
    }
  }
}